/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import SalesChatWidget from '../components/salesChatWidget';

function ProductSalesAgent() {
  return (
    <div className="main">
      <Header />
      <SalesChatWidget />
      <Footer />
    </div>
  );
}

export default ProductSalesAgent;
